import axiosWithAuth from './axiosWithAuth';

// Plan Management API
export const planAPI = {
    // Get all plans
    getAllPlans: () => axiosWithAuth.get('/admin/plans'),

    // Get specific plan
    getPlan: (id) => axiosWithAuth.get(`/admin/plans/${id}`),

    // Create new plan
    createPlan: (data) => axiosWithAuth.post('/admin/plans', data),

    // Update plan
    updatePlan: (id, data) => axiosWithAuth.put(`/admin/plans/${id}`, data),

    // Delete plan
    deletePlan: (id) => axiosWithAuth.delete(`/admin/plans/${id}`),

    // Toggle plan status
    togglePlanStatus: (id) => axiosWithAuth.post(`/admin/plans/${id}/toggle-status`),

    // Get plan usage stats
    getPlanUsageStats: (id) => axiosWithAuth.get(`/admin/plans/${id}/usage-stats`),


    // Service assignment APIs removed - using environment-based configuration instead
};

// External Services API removed - using environment-based configuration instead 